
import { useState } from 'react';
import { SportType } from '@/types/sport';
import { Database } from '@/integrations/supabase/types';

type ClubRow = Database['public']['Tables']['clubs']['Row'];

export const useClubForm = () => {
  const [clubName, setClubName] = useState('');
  const [clubWebsite, setClubWebsite] = useState('');
  const [clubLocation, setClubLocation] = useState('');
  const [clubProfilePicture, setClubProfilePicture] = useState('');
  const [clubSport, setClubSport] = useState<SportType | ''>('');

  const resetForm = () => {
    setClubName('');
    setClubWebsite('');
    setClubLocation('');
    setClubProfilePicture('');
    setClubSport('');
  };

  const setFormData = (club: ClubRow) => {
    setClubName(club.name);
    setClubWebsite(club.website || '');
    setClubLocation(club.location || '');
    setClubProfilePicture(club.profile_picture_url || '');
    setClubSport((club.sport as SportType) || '');
  };

  return {
    clubName,
    clubWebsite,
    clubLocation,
    clubProfilePicture,
    clubSport,
    setClubName,
    setClubWebsite,
    setClubLocation,
    setClubProfilePicture,
    setClubSport,
    resetForm,
    setFormData
  };
};
